import { makeAutoObservable } from 'mobx'
import CheckableMap from 'src/models/CheckableMap'

import { LegacyArithmeticWorksheet } from './LegacyArithmeticWorksheet'

export class LegacyArithmeticWorksheetColl {
  constructor(
    private workSheetMap: CheckableMap<LegacyArithmeticWorksheet['id'], LegacyArithmeticWorksheet>
  ) {
    makeAutoObservable(this)
  }

  get toArr() {
    return [...this.workSheetMap.values()]
  }

  get checkSize() {
    return this.workSheetMap.checkSize
  }

  get checkedIds() {
    return this.workSheetMap.toCheckedKeys
  }

  get toCheckedValues() {
    return this.workSheetMap.toCheckedValues.sort((prev, cur) => prev.id - cur.id)
  }

  toggleCheck(key) {
    return this.workSheetMap.toggleCheck(key)
  }

  isChecked(key) {
    return this.workSheetMap.isChecked(key)
  }

  get isAllChecked() {
    return this.workSheetMap.isFullyChecked
  }

  get isPartiallyChecked() {
    return this.workSheetMap.isPartChecked
  }

  toggleAllCheck() {
    return this.workSheetMap.toggleAllCheck()
  }

  clearAllCheck() {
    return this.workSheetMap.clearAllCheck()
  }

  adds(workSheetColl: LegacyArithmeticWorksheetColl) {
    this.workSheetMap.adds(workSheetColl.workSheetMap.entries())
  }
}
